import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RadioButton from '@components/BaseComponents/RadioButton';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Body, Caption, Small } from 'deltoid/core/Blocks/Typography';
import Form from 'deltoid/core/Form';
import Dialog from './Dialog';
import { ConsentAndXML } from '@components/KYC/Aadhar';
import CKYC from '@components/KYC/CKYC';
import Address from '@components/KYC/Address';

import { dialogActions, kycActions, kycSelectors, toastActions, merchantSelectors } from '@store/ducks';

const KYC = ({
  closeDialog,
  filled,
  editable,
  why,
  getRegistrationAddress,
  getOperatingAddress,
}) => {
  const [kycOptionSelected, setKycOption] = useState(
    getRegistrationAddress || getOperatingAddress ? 'manual' : 'aadharKyc'
  );
  return (
    <>
    <Row noGutters={filled}>
      {
        filled ? <Address editable={editable} filled={filled} why={why} isManual={false}/> : (
          <>
            <Col className='mx-4 pb-3' md={12}>
              <Small variant='medium' className='pb-2'>Choose a KYC option</Small>
              <RadioButton
                className='pr-3 pb-2'
                name='kycOptions'
                value={'ckyc'}
                checked={kycOptionSelected === 'ckyc'}
                label='Fetch from cKYC'
                onChange={(e) => setKycOption(e.target.value)}
              />
              <RadioButton
                className='pr-3 pb-2'
                name='kycOptions'
                value={'aadharKyc'}
                checked={kycOptionSelected === 'aadharKyc'}
                label='Fetch from Aadhar'
                onChange={(e) => setKycOption(e.target.value)}
              />
              <RadioButton
                name='kycOptions'
                value={'manual'}
                checked={kycOptionSelected === 'manual'}
                label='Upload documents manually'
                onChange={(e) => setKycOption(e.target.value)}
              />
            </Col>
            <Col md={12}>
              {
                kycOptionSelected === 'ckyc' && <CKYC why={why} />
              }
              {
                kycOptionSelected === 'aadharKyc' && <ConsentAndXML why={why}/>
              }
              {
                kycOptionSelected === 'manual' && (
                  <Address editable={true} why={why} isManual={true}/>
                )
              }
            </Col>
          </>
        )
      }
    </Row>
    <Dialog onClose={closeDialog}/>
    </>
  )
};

const mapStateToProps = (state) => ({
  ckycVerifying: kycSelectors.ckycVerifying(state),
  aadharConsentProcessing: kycSelectors.aadharConsentProcessing(state),
  getRegistrationAddress: merchantSelectors.getRegistrationAddress(state),
  getOperatingAddress: merchantSelectors.getOperatingAddress(state),
})

const mapDispatchToProps = dispatch => ({
  closeDialog: () => dispatch(dialogActions.close()),
  ckyc: () => dispatch(dialogActions.open('ckyc')),
  verifyCKYC: () => dispatch(kycActions.fetchCKYC()),
  verifyAadharXML: () => dispatch(kycActions.aadharConsent()),
  showToast: (toastProps) => dispatch(toastActions.show(toastProps)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KYC);
